import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';
import eyeHideIcon from '@/assets/img/login/eye-hide.png';

const EyeHideIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <img src={eyeHideIcon} alt="" width={20} height={20} />
  </span>
);

export default EyeHideIcon;
